var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMyTerm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2701_162908",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2701_162908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 21.5C5.30133 21.5 4.71 21.258 4.226 20.774C3.742 20.29 3.5 19.6987 3.5 19V17.923C3.5 17.426 3.677 17.0005 4.031 16.6465C4.385 16.2925 4.81058 16.1155 5.30775 16.1155H6.5V4.30775C6.5 3.81058 6.677 3.385 7.031 3.031C7.385 2.677 7.81058 2.5 8.30775 2.5H18.6923C19.1894 2.5 19.615 2.677 19.969 3.031C20.323 3.385 20.5 3.81058 20.5 4.30775V19C20.5 19.6987 20.258 20.29 19.774 20.774C19.29 21.258 18.6987 21.5 18 21.5H6ZM18 20C18.2833 20 18.5208 19.9042 18.7125 19.7125C18.9042 19.5208 19 19.2833 19 19V4.30775C19 4.21792 18.9712 4.14417 18.9135 4.0865C18.8558 4.02883 18.7821 4 18.6923 4H8.30775C8.21792 4 8.14417 4.02883 8.0865 4.0865C8.02883 4.14417 8 4.21792 8 4.30775V16.1155H15.1923C15.6894 16.1155 16.115 16.2925 16.469 16.6465C16.823 17.0005 17 17.426 17 17.923V19C17 19.2833 17.0958 19.5208 17.2875 19.7125C17.4792 19.9042 17.7167 20 18 20ZM9.94225 8.69225C9.72975 8.69225 9.55167 8.62033 9.408 8.4765C9.26417 8.33267 9.19225 8.1545 9.19225 7.942C9.19225 7.72933 9.26417 7.55125 9.408 7.40775C9.55167 7.26408 9.72975 7.19225 9.94225 7.19225H17.0577C17.2702 7.19225 17.4483 7.26417 17.592 7.408C17.7358 7.55183 17.8077 7.73008 17.8077 7.94275C17.8077 8.15525 17.7358 8.33333 17.592 8.477C17.4483 8.6205 17.2702 8.69225 17.0577 8.69225H9.94225ZM9.94225 11.577C9.72975 11.577 9.55167 11.5051 9.408 11.3613C9.26417 11.2174 9.19225 11.0392 9.19225 10.8265C9.19225 10.614 9.26417 10.4359 9.408 10.2923C9.55167 10.1488 9.72975 10.077 9.94225 10.077H17.0577C17.2702 10.077 17.4483 10.1489 17.592 10.2928C17.7358 10.4364 17.8077 10.6146 17.8077 10.8273C17.8077 11.0399 17.7358 11.218 17.592 11.3615C17.4483 11.5052 17.2702 11.577 17.0577 11.577H9.94225ZM6 20H15.5V17.923C15.5 17.8333 15.4712 17.7597 15.4135 17.702C15.3558 17.6442 15.2821 17.6152 15.1923 17.6152H5.30775C5.21792 17.6152 5.14417 17.6442 5.0865 17.702C5.02883 17.7597 5 17.8333 5 17.923V19C5 19.2833 5.09583 19.5208 5.2875 19.7125C5.47917 19.9042 5.71667 20 6 20ZM6 20H5H15.5H6Z",
    fill: "#B6BCC8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyTerm);
export default __webpack_public_path__ + "static/media/icon_my_term.17726dcb0b92838ad785473a37244d26.svg";
export { ForwardRef as ReactComponent };